export default "__VITE_ASSET__5f180631__"